import InputUi from './input';
import TextareaUi from './textarea';

export const Input = InputUi;
export const Textarea = TextareaUi;
